;

// Input filled
// functions are in global scope because of call in paypal-buttons.html.twig

function checkIfEmpty() {
    $('.form__input, .form__textarea').on('input', function () {
        $(this).closest('div').addClass('input--filled')
    })
    var empty = false
    $('.form__input, .form__textarea').each(function () {
        if ($(this).val().trim() == '') {
            empty = true
            $(this).closest('div').removeClass('input--filled')
        } else {
            $(this).closest('div').addClass('input--filled')
        }
    })
}

function checkIfEmptyClick() {
    $(document).bind('click', function () {
        var empty = false
        $('.form__input, .form__textarea').each(function () {
            if ($(this).val().trim() == '') {
                empty = true
                $(this).closest('div').removeClass('input--filled')
            } else {
                $(this).closest('div').addClass('input--filled')
            }
        })
    })
}

(function($) {
    checkIfEmpty()
    checkIfEmptyClick()
}(jQuery));
